module.exports = __webpack_public_path__ + "static/team-family-bb3e52e74992d7a59920ed4d18a7d532.jpg";